__turbopack_context__.v({
  "full-size-position": "Modal-module__nt2kka__full-size-position",
});
